import { apiSlice } from "../../app/api/apiSlice";

export const fetchStandardDocumentUploadRetriesPendingRetryApiSlice =
	apiSlice.injectEndpoints({
		endpoints: (builder) => ({
			standardDocumentUploadRetriesPendingRetry: builder.mutation({
				query: (credentials) => ({
					url: `api/v1/loan/get_standard_document_upload_retries_pending_retry/${credentials.loanGuid}/`,
					method: "GET",
				}),
			}),
		}),
	});

export const { useStandardDocumentUploadRetriesPendingRetryMutation } =
	fetchStandardDocumentUploadRetriesPendingRetryApiSlice;
